const e = {
  name: "Accounts",
  dimensions: { width: 20, height: 20 },
  content: `
    <svg fill="currentColor">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0C0.895431 0 0 0.89543 0 2V7C0 8.10457 0.89543 9 2 9H7C8.10457 9 9 8.10457 9 7V2C9 0.895431 8.10457 0 7 0H2ZM2 2H7V7H2V2Z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13 11C11.8954 11 11 11.8954 11 13V18C11 19.1046 11.8954 20 13 20H18C19.1046 20 20 19.1046 20 18V13C20 11.8954 19.1046 11 18 11H13ZM13 13H18V18H13V13Z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 2C11 0.89543 11.8954 0 13 0H18C19.1046 0 20 0.895431 20 2V7C20 8.10457 19.1046 9 18 9H13C11.8954 9 11 8.10457 11 7V2ZM18 2H13V7H18V2Z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 11C0.895431 11 0 11.8954 0 13V18C0 19.1046 0.89543 20 2 20H7C8.10457 20 9 19.1046 9 18V13C9 11.8954 8.10457 11 7 11H2ZM2 13H7V18H2V13Z"/>
    </svg>
  `
};
export {
  e as Accounts
};
